import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as FreeSvgSolidIcons from '@fortawesome/free-solid-svg-icons'
import Wrapper from '../Wrapper';
// import * as FreeSvgBrandIcons from '@fortawesome/free-brands-svg-icons'
export default class FontIcon extends React.Component {
    render() {
        return <FontAwesomeIcon {...this.props} className={`hms-font-icon ${this.props.className || ''}`} />
    }
}

export const SolidIcons = FreeSvgSolidIcons;
// export const BrandIcons = FreeSvgBrandIcons;